import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { t } from 'i18next';
import InlineTable, { InlineColDef } from '../util/InlineTable';

interface Task { id: number; name: string; active: boolean | null; }

const columns: InlineColDef<Task>[] = [
  { key: 'name', label: t('Name') || 'Name', type: 'text', placeholder: t('Name') || 'Task name…' },
];

const Tasks: React.FC = () => {
  const [rows, setRows] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await axios.get('task/tasks/all'); setRows(Array.isArray(data) ? data : []); }
    catch {} finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleAdd = async (row: Partial<Task>) => {
    if (!row.name?.trim()) return;
    await axios.post('task/add', { name: row.name.trim() });
    await load();
  };

  const handleEdit = async (id: string | number, row: Partial<Task>) => {
    await axios.put(`task/updateTask/${id}`, { name: row.name });
    await load();
  };

  const handleDelete = async (id: string | number) => {
    if (!window.confirm(t('AreYouSure') || 'Are you sure?')) return;
    await axios.delete(`task/deleteTask/${id}`);
    await load();
  };

  return (
    <div className="bg-[var(--bg-form)] rounded-[5px]" style={{ border: 'var(--border-input)', overflow: 'hidden' }}>
      <InlineTable<Task>
        columns={columns}
        rows={rows}
        getKey={r => r.id}
        loading={loading}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
        addLabel={`+ ${t('TasksType') || 'Task'}`}
        emptyText={t('Empty') || 'No tasks'}
      />
    </div>
  );
};

export default Tasks;
